import script from "./ExportPaymentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ExportPaymentModal.vue?vue&type=script&setup=true&lang=js"

import "./ExportPaymentModal.vue?vue&type=style&index=0&id=36d17f38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36d17f38"]])

export default __exports__